import { features } from "@/mocks/home";

export default function Features() {
  return (
    <section id="features" className="anchor-offset bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-3 md:max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">核心功能</span>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
            六种方式，让你更容易遇见聊得来的人
          </h2>
          <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
            从推荐到群聊再到线下活动，爱情岛把「认识一个人」拆成几个轻松的步骤。你不必一开始就抱着目的，
            先从感兴趣的一环入手就好。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <article
              key={feature.title}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${feature.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-800">
                  {feature.tag}
                </span>
              </div>
              <h3 className="font-heading text-lg text-foreground-950">{feature.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}